"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var typography_1 = require("../../typography");
var Button_1 = __importDefault(require("../../basics/Button"));
var ContentfulRichText_1 = __importDefault(require("../../utils/ContentfulRichText"));
var styles_1 = require("./styles");
var RICH_TEXT_1_OVERRIDES = {
    paragraph: function (_, c) { return (react_1.default.createElement(typography_1.Body, { level: "3", color: "GREY_90", maxWidth: 26 }, c)); },
};
var LibraryGuideBlock = function (_a) {
    var title = _a.title, description = _a.description, link = _a.link, image = _a.image, _b = _a.imageBackgroundColor, imageBackgroundColor = _b === void 0 ? 'YELLOW_20' : _b, commonProps = __rest(_a, ["title", "description", "link", "image", "imageBackgroundColor"]);
    return (react_1.default.createElement(styles_1.Wrapper, __assign({ "data-component-name": "LibraryGuideBlock" }, commonProps),
        react_1.default.createElement(styles_1.ImageWrapper, { "$backgroundColor": imageBackgroundColor },
            react_1.default.createElement(styles_1.Image, __assign({}, image, { alt: "".concat(title, " artwork") }))),
        react_1.default.createElement(styles_1.Content, null,
            react_1.default.createElement(typography_1.Label, { level: "1", color: "GREY_80" }, "Guide"),
            react_1.default.createElement(typography_1.Heading, { level: "3", color: "BLUE_50" }, title),
            react_1.default.createElement(styles_1.Description, null,
                react_1.default.createElement(ContentfulRichText_1.default, { nodeOverrides: RICH_TEXT_1_OVERRIDES }, description)),
            react_1.default.createElement(styles_1.Footer, null,
                react_1.default.createElement(Button_1.default, __assign({ version: "outline" }, link), "Read the guide")))));
};
exports.default = LibraryGuideBlock;
